import { mergeClassnames } from '@heathmont/moon-core-tw';
import NextLink from '~/client/shared/NextLink';
import BreadcrumbNextIcon from './BreadcrumbNextIcon';
import Translate from '../../i18n/Translate';

type Props = {
  breadcrumb: Breadcrumb;
  isLast?: boolean;
  size?: 'large' | 'default';
};

const BreadcrumbItem: FC<Props> = ({
  children,
  isLast,
  size = 'default',
  breadcrumb: { to, translateVariables, translateId = '' },
}) => (
  <div className="inline-container">
    {to ? (
      <NextLink href={to}>
        <p
          className={mergeClassnames(
            'text-moon-12 text-trunks',
            size === 'large' && 'text-moon-16',
          )}
        >
          {children ?? (
            <Translate id={translateId} values={translateVariables} />
          )}
        </p>
      </NextLink>
    ) : (
      <p
        className={mergeClassnames(
          'text-moon-12 text-bulma',
          size === 'large' && 'text-moon-16',
        )}
      >
        {children ?? <Translate id={translateId} values={translateVariables} />}
      </p>
    )}
    {!isLast && <BreadcrumbNextIcon />}
  </div>
);

export default BreadcrumbItem;
